import { render, staticRenderFns } from "./GuoJiaolianManage.vue?vue&type=template&id=15b3c5b8&"
import script from "./GuoJiaolianManage.vue?vue&type=script&lang=js&"
export * from "./GuoJiaolianManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports